import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { postFormData } from 'utils/service';
  // declaring the types for our state
  export type NotificationState = {
    data: any;
    pending: boolean;
  };
  
  const initialState: NotificationState = {
    data: [],
    pending: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getNotificationData = createAsyncThunk('api/notifications', async () => {
    let data: any = { }
    let response: any = await postFormData('notifications', data);
    if (response.success === "true") {
      return response
    }
    return {};
  });
  
  export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
    },

    extraReducers: builder => {
      builder
        .addCase(getNotificationData.pending, state => {
          state.pending = true;
        })
        .addCase(getNotificationData.fulfilled, (state, { payload }) => {
          state.pending = false;
          state.data = payload.data;
        });
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
   
  } = notificationSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectNotification = (state: RootState) => state.notifications;
  
  // exporting the reducer here, as we need to add this to the store
  export default notificationSlice.reducer;